export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.7.2-1337.23",
  commitId: "ad381cd43891e8932095231294be10fbae40cd82",
  commitTime: "2026-07-02T13:37:23.000Z",
});
